import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const classes = `
    inline-flex items-center justify-center px-8 py-4 
    bg-dark-green text-white font-sans font-medium text-lg tracking-wide
    rounded-none hover:bg-near-black transition-colors duration-300
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-green
    shadow-sm hover:shadow-md
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-155">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} {...props} data-id="element-156">
      {children}
    </button>;
}